function Technology() {
    return (
        <div />
    );
}

export default Technology;